// ─── Revenir à l'écran PRÉCÉDENT, pas à la liste ──────────────────
// Demandé par Cédric le 13/08 après vérification : « à la fermeture d'un
// écran, on revient bien directement sur l'écran précédent ? » — la réponse
// était NON, et systématiquement.
//
// POURQUOI c'était cassé : deux <Modal> natives imbriquées figent l'écran
// (piège documenté). Pour ouvrir un écran depuis un autre, on FERMAIT donc le
// premier :  `setFicheLigne(null); setOccARattacher(o);`
// Résultat : en fermant le second, on retombait sur la LISTE — l'écran d'où
// l'on venait avait disparu, et avec lui la place qu'on y tenait.
//
// Ce hook garde la trace du chemin. On empile « comment revenir » au moment
// d'ouvrir, on dépile à la fermeture.
//
//   const retour = usePileRetour();
//   // ouvrir B depuis A :
//   onOuvrirB={() => { retour.empiler(() => setA(valeurA)); setA(null); setB(x); }}
//   // fermer B :
//   onFermer={() => { setB(null); retour.revenir(); }}
//
// ⚠️ `useRef` et non `useState` : la pile n'est pas affichée, la re-rendre
// serait du travail pour rien — et surtout, empiler pendant le rendu d'une
// transition provoquerait une boucle.
import { useRef, useCallback } from 'react';

export default function usePileRetour() {
  const pile = useRef([]);

  // `retour` doit être une FONCTION qui rouvre l'écran quitté.
  const empiler = useCallback((retour) => {
    if (typeof retour === 'function') pile.current.push(retour);
  }, []);

  // Rejoue le dernier retour. Renvoie `false` s'il n'y avait rien à rouvrir —
  // l'appelant sait alors qu'il vient de revenir à la liste, ce qui est
  // parfois l'information utile.
  const revenir = useCallback(() => {
    const r = pile.current.pop();
    if (!r) return false;
    r();
    return true;
  }, []);

  // À appeler quand le chemin n'a plus de sens : l'élément d'où l'on venait a
  // été supprimé, ou l'utilisateur a quitté la section. Rouvrir une fiche sur
  // un objet disparu vaudrait moins que ne rien rouvrir du tout.
  const vider = useCallback(() => { pile.current = []; }, []);

  return { empiler, revenir, vider };
}
